module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elStartplaying_971971.61773a12.jpg";